import faqContent from "./content/faq.json";

export const faqMock = {
  name: "faq",
  layoutType: 1,
  areasList: [
    {
      id: "faq-1",
      name: "faq-content",
      componentName: "Comp:FaqPage",
      content: JSON.stringify(faqContent),
    },
  ],
};
